import React, { useState, useContext, useEffect, useRef } from 'react';
import nookies from 'nookies';
import { withAuth0 } from '@auth0/auth0-react';
import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider';
import ErrorBanner from '@ntuctech/devex-tangram/ErrorBanner/ErrorBanner';
import SvgAlert from '@ntuctech/devex-tangram/Icon/SvgAlert';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import _get from 'lodash.get';
import lodash, { isEmpty } from 'lodash';
import Grid from '@ntuctech/devex-tangram/Grid';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';
import { useFeatureFlag } from '../FeatureFlagProvider';
import Loader from '../Theme/Loader';
import Text from '../Text/Text';
import { SCREEN_SIZE } from '../../lib/mediaQuery';
import Preview, { PreviewModel, errorHandler } from './component/Preview';
import PageFooter from '../Theme/PageFooter';
import { HeaderWrapper, PageContent } from '../Shared';
import { CustomiseVoucherContext } from '../Context/Context';
import { getViewGuest } from '../../services/api/api';
import 'react-datepicker/dist/react-datepicker.css';
import VoucherCategories from './component/VoucherCategories';
import RecipientSection from './component/RecipientSection';
import VoucherFooterSection from './component/VoucherFooterSection';
import ErrorUnauthorized from '../../services/fetch/errorUnauthorized';
import { EventTrackingContext } from '../EventTrackingProvider/EventTrackingProvider';

import BussinessQuantity from './component/BusinessQuanity';
import DeliveryInformation from './component/DeliveryInformation';
import BillingAddress from './component/BillingAddress';
import BusinessPreview from './component/BusinessPreview';
import {
  CATEGORY,
  GTM_ENV_VAR as GEV,
  PAGE_TYPES,
  SCREEN_NAME,
} from '../../lib/eventTrackerFunction';
import { LAST_ACTIVITY } from '../../constants';
import TosterComponent from '../Toster/TosterComponent';
import { isPastDate } from '../../utils/Utils';
import MobileModelComponent from './component/MobileModel';
import BreadCrumb from '../../containers/BreadCrumb';
import { addToCartBusiness } from './utils';
import { AMP_EVENT_NAME } from '../../lib/amplitude';
import AddMessage from './component/AddMessage';
import useBusinessEntityData from '../../hooks/useBusinessEntityData';
import { useAppContext } from '../../lib/contextProviders/contexts/appContext';
import { useUserContext } from '../../lib/contextProviders/contexts/userContext';

/* eslint-disable no-useless-escape */
const validateEmail = (email) =>
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );

const phoneFormat = (phone) => /^(?:\+65)?[689][0-9]{7}$/.test(phone);

const EGIFTING_CUSTOMIZE = 'egifting | customize selection';
const getCustomisationList = (voucherMetaData) => {
  const grouping =
    voucherMetaData.filter(
      (item) => !isPastDate(item?.end, true) && isPastDate(item?.start, true)
    ) || [];
  return grouping.filter(
    (tag, index, array) => array.findIndex((item) => item.catergory === tag.catergory) === index
  );
};

const WrpDiv = styled.div`
  h5,
  h6 {
    margin: 0;
  }

  ${SCREEN_SIZE.Only.Tablet} {
    flex: 1;
    margin-bottom: 0;
  }

  @media only screen and (max-width: 767) {
    margin: 0;
  }

  ${SCREEN_SIZE.From.Desktop} {
    flex: 0;
    flex-basis: 100%;
    padding-bottom: 8px;
    max-width: 100%;
    display: flex;
    justify-content: center;
  }
`;

const StyledButton = styled.button`
  background: inherit;
  color: inherit;
  border: 0;
  text-decoration: underline;
  cursor: pointer;
`;

const Container = styled.div`
  .no-spacing {
    padding-left: 0;
    padding-right: 0;
  }
  .header-space {
    padding: 1.5rem 0 !important;
    ${SCREEN_SIZE.Below.MobileL} {
      padding: 1rem !important;
    }
  }
  .margin-left-16 {
    margin-left: 1rem;
  }
  ${SCREEN_SIZE.From.Tablet} {
    display: flex;
    max-width: 100%;
  }

  ${SCREEN_SIZE.Only.Tablet} {
    > :first-child {
      width: 24.5rem;
    }
  }

  ${SCREEN_SIZE.Only.Mobile} {
    margin-bottom: '6rem';
  }

  ${SCREEN_SIZE.Only.MobileL} {
    margin-bottom: '6rem';
  }
`;

const MainTitle = styled.div`
  > span:nth-child(1) {
    font-style: normal;
    font-weight: 700;
    font-size: 23px;
    line-height: 32px;
    color: #333333;
  }
`;

const GridSeven = styled(Grid)`
  @media screen and (min-width: 768px) {
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 0px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
`;

const GridPreview = styled(Grid)`
  top: 0;
  padding-left: 1rem;
  padding-right: 0;
  ${SCREEN_SIZE.Below.MobileL} {
    padding: 0;
    bottom: 0;
    position: sticky;
    margin-left: 0;
  }
`;

const BusinessGridStyle = styled.div`
  top: 13%;
  position: sticky;
  margin: 0 0 1rem 0;
  ${SCREEN_SIZE.Below.MobileL} {
    margin: 0;
  }
`;

const GridFive = styled.div`
  top: 13%;
  position: sticky;
  ${SCREEN_SIZE.From.Tablet} {
    margin-bottom: 1rem;
  }
  @media screen and (min-width: 768px) {
    ::-webkit-scrollbar {
      width: 0px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
`;

const ShowFooterSection = styled.div`
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
  }
`;

const StyledErrorBanner = styled(ErrorBanner)`
  margin-bottom: 1rem;
  width: 100% !important;
  @media screen and (max-width: 768px) {
    margin-bottom: 0.5rem !important;
  }
`;

const StyledContainer = styled(Grid)`
  width: 100%;
  max-width: 75rem;
  padding: 0 4rem !important;
  ${SCREEN_SIZE.Only.Tablet} {
    padding: 0 2rem !important;
  }
  ${SCREEN_SIZE.Below.MobileL} {
    padding: 0 !important;
  }
  margin-bottom: 2.75rem;
`;

const isDescendant = (parent, child) => {
  let node = child;
  while (node != null) {
    if (node?.isEqualNode(parent.current)) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

const dummyarray = {
  name: '',
  email: '',
  phone: '',
  deliveryMethod: 'email',
  count: 1,
};

let AgreegateRecipient;
let enableRecipient;
let recipientTrack;

const Agreegate = (receivers, setRecepient) => {
  const group = lodash.groupBy(
    receivers,
    receivers[0]?.deliveryMethod === 'sms' ? 'phone' : 'email'
  );
  AgreegateRecipient = lodash.map(lodash.keys(group), function aggrigation(e) {
    return lodash.reduce(
      group[e],
      function aggrigate(r, o) {
        const R = r;
        R.name = o.name;
        R.email = o.email;
        R.phone = o.phone;
        R.deliveryMethod = o.deliveryMethod;

        return R;
      },
      {
        name: e,
        count: group[e].length,
        email: undefined,
        phone: undefined,
        deliveryMethod: undefined,
      }
    );
  });
  setRecepient(AgreegateRecipient);
};

const RenderCustomiseBody = ({
  voucherData,
  setVoucherData,
  manuallyMsg,
  setManuallymsg,
  isEnableCategories,
  filteredImg,
  setCategory,
  category,
  counterInputRef,
  recepient,
  setRecepient,
  entityData,
  isEditMode,
  isB2bEnabled,
  track,
  isCheck,
  setIsCheck,
  voucherMetaData,
}) => {
  if (isB2bEnabled) {
    return (
      <>
        <VoucherCategories
          voucherData={voucherData}
          setVoucherData={setVoucherData}
          manuallyMsg={manuallyMsg}
          setManuallymsg={setManuallymsg}
          selectOptions={isEnableCategories}
          filteredImg={filteredImg}
          setCategory={setCategory}
          category={category}
          counterInputRef={counterInputRef}
          isB2bEnabled={isB2bEnabled}
          track={track}
          voucherMetaData={voucherMetaData}
        />
        <AddMessage
          isB2bEnabled={isB2bEnabled}
          voucherData={voucherData}
          setVoucherData={setVoucherData}
          setManuallymsg={setManuallymsg}
          counterInputRef={counterInputRef}
        />
        <BussinessQuantity
          isEditMode={isEditMode}
          setVoucherData={setVoucherData}
          voucherData={voucherData}
          track={track}
        />
        <DeliveryInformation
          setIsCheck={setIsCheck}
          isCheck={isCheck}
          setVoucherData={setVoucherData}
          voucherData={voucherData}
          isEditMode={isEditMode}
        />
        <BillingAddress setVoucherData={setVoucherData} entityData={entityData} />
      </>
    );
  }

  return (
    <>
      <VoucherCategories
        voucherData={voucherData}
        setVoucherData={setVoucherData}
        manuallyMsg={manuallyMsg}
        setManuallymsg={setManuallymsg}
        selectOptions={isEnableCategories}
        filteredImg={filteredImg}
        setCategory={setCategory}
        category={category}
        counterInputRef={counterInputRef}
        track={track}
        voucherMetaData={voucherMetaData}
      />

      <RecipientSection
        voucherData={voucherData}
        setVoucherData={setVoucherData}
        Agreegate={Agreegate}
        counterInputRef={counterInputRef}
        recepient={recepient}
        setRecepient={setRecepient}
        AgreegateRecipient={AgreegateRecipient}
        dummyarray={dummyarray}
      />

      <VoucherFooterSection
        voucherData={voucherData}
        setVoucherData={setVoucherData}
        setManuallymsg={setManuallymsg}
        counterInputRef={counterInputRef}
      />
    </>
  );
};

const CustomisePage = (props) => {
  const {
    voucherData,
    setVoucherData,
    manuallyMsg,
    setManuallymsg,
    filteredImg,
    setCategory,
    category,
    recepient,
    setRecepient,
    counterInputRef,
    track,
    trackEvents,
    errorBannerTestProps,
    errorMessage,
    loginWithRedirect,
    entityData,
    isB2bEnabled,
  } = props;

  const isKeyboardOpen = useDetectKeyboardOpen();
  const { isEditMode, setIsEditMode, voucherMetaData } = useContext(CustomiseVoucherContext);
  const {
    appState: { siteType },
  } = useAppContext();
  const {
    userState: { auth0Token },
  } = useUserContext();
  const [isError, setIsError] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [errorBanner, setErrorBanner] = React.useState({
    show: errorBannerTestProps,
    message: errorMessage,
  });

  useEffect(() => {
    setTimeout(() => {
      track({
        [GEV.AMPLITUDE_EVENT_NAME]: AMP_EVENT_NAME.PAGE_TILE,
        [GEV.EVENT_CAT]: 'Egifting',
        [GEV.AMPLITUDE_PROPERTY_TYPE]: 'Event Property',
        [GEV.MEMBER_TYPE]: siteType,
        [GEV.AMPLITUDE_VERTICAL]: AMP_EVENT_NAME.VERTICAL,
        [GEV.AMPLITUDE_CTA_LOCATION]: EGIFTING_CUSTOMIZE,
        [GEV.AMPLITUDE_CTA_SUB_LOCATION]: null,
      });
    }, 2000);
  }, [track]);

  const addToCartBusinessHandler = (e) => {
    addToCartBusiness({
      e,
      voucherData,
      entityData,
      isEditMode,
      setErrorBanner,
      errorHandler,
      auth0Token,
    });
  };

  const validateRecipient = (data) => {
    return data.every((item) => {
      if (item.deliveryMethod === 'email') {
        return item.email && item.email.trim() !== '' && validateEmail(item.email.trim());
      }

      if (['phone', 'sms'].includes(item.deliveryMethod)) {
        return item.phone && item.phone.trim() !== '' && phoneFormat(item.phone.trim());
      }

      return false;
    });
  };

  const isEnabled =
    voucherData.amount <= 1000 &&
    voucherData.amount !== '' &&
    voucherData.amount > 0 &&
    `${voucherData.metadata.image}` &&
    voucherData.sender &&
    Array.isArray(voucherData.receivers) &&
    validateRecipient(voucherData.receivers) &&
    enableRecipient;

  const isEnabledSaveBtn =
    parseInt(voucherData.amount / voucherData.quantity, 10) <= 1000 &&
    voucherData.amount !== '' &&
    voucherData.amount > 0 &&
    `${voucherData.metadata.image}` &&
    voucherData.sender &&
    Array.isArray(voucherData.receivers) &&
    validateRecipient(voucherData.receivers) &&
    enableRecipient;
  const grouping = voucherMetaData.filter(
    (item) => !isPastDate(item?.end, true) && isPastDate(item?.start, true)
  );
  const isEnableCategories = grouping.filter(
    (tag, index, array) => array.findIndex((item) => item.catergory === tag.catergory) === index
  );
  isEnableCategories.unshift({
    catergory: 'all',
    title: 'All',
    start: '1970-01-01',
  });
  const isB2bButtonEnabled = () => {
    const hasEmail = Boolean(voucherData.businessEmail || voucherData.otherBusinessEmail);
    const haveQty =
      voucherData.bussinessData?.reduce((acc, val) => Number(acc) + Number(val.qty), 0) > 0;
    return hasEmail && haveQty;
  };

  const getErrorMessage = () => {
    switch (errorBanner.message) {
      case 1:
        return 'You’ve exceeded the maximum quantity of 999 total vouchers for this selection. Edit quantity and try again.';
      case 2:
        return (
          <>
            Your session has timed out.{' '}
            <StyledButton
              size="s"
              data-testid="login-error"
              onClick={() => {
                loginWithRedirect({
                  redirectUri: window.location.origin,
                  appState: { returnTo: window.location.href },
                });
              }}
            >
              Log in
            </StyledButton>{' '}
            again to continue.
          </>
        );
      case 3:
        return 'Unprocessable Entity';
      case 4:
        return 'You’ve exceeded the maximum quantity of 400,000 total vouchers for this selection. Edit quantity and try again.';
      default:
        return '';
    }
  };

  return (
    <StyledContainer container>
      <Grid className="no-spacing" xs={12}>
        <Grid item xs={12} className="no-spacing">
          <BreadCrumb isB2B={isB2bEnabled} track={track} />
          <HeaderWrapper isB2bEnabled={isB2bEnabled} className="no-spacing header-space">
            <MainTitle data-testid="customisevoucher">
              {isB2bEnabled ? (
                <Text size="xl" color="#333333" weight="bold" fontFamily="Lato">
                  {isEditMode === true ? 'Edit your voucher' : 'Send E-Gift Vouchers for Business'}
                </Text>
              ) : (
                <Text size="xl" color="#333333" weight="bold" fontFamily="Lato">
                  {isEditMode === true ? 'Edit your voucher' : 'Send personal E-Gift Vouchers'}
                </Text>
              )}
            </MainTitle>
          </HeaderWrapper>
        </Grid>

        <Grid item xs={12} className="no-spacing">
          {errorBanner.show ? (
            <StyledErrorBanner
              data-testid="errorbanner-toaster"
              label={getErrorMessage()}
              attentionLevel="high"
              style={{ marginBottom: '1rem' }}
              icon={<SvgAlert />}
              fullWidth
              action="Action"
              {...props}
            />
          ) : null}
        </Grid>
        <Grid container xs={12} className="no-spacing">
          <Grid item id="left" s={7} className="no-spacing">
            <GridSeven className="no-spacing">
              <RenderCustomiseBody
                voucherData={voucherData}
                setVoucherData={setVoucherData}
                manuallyMsg={manuallyMsg}
                setManuallymsg={setManuallymsg}
                isEnableCategories={isEnableCategories}
                filteredImg={filteredImg}
                setCategory={setCategory}
                category={category}
                counterInputRef={counterInputRef}
                recepient={recepient}
                setRecepient={setRecepient}
                entityData={entityData}
                isEditMode={isEditMode}
                isB2bEnabled={isB2bEnabled}
                track={track}
                isCheck={isCheck}
                voucherMetaData={voucherMetaData}
                setIsCheck={setIsCheck}
              />
            </GridSeven>
          </Grid>
          <GridPreview
            id="right"
            isEditMode={isEditMode}
            show={errorBanner.show}
            isB2bEnabled={isB2bEnabled}
            item
            s={5}
          >
            {isB2bEnabled ? (
              <BusinessGridStyle>
                <BusinessPreview
                  voucherData={voucherData}
                  setErrorBanner={setErrorBanner}
                  entityData={entityData}
                  isEditMode={isEditMode}
                  isB2bEnabled={isB2bEnabled}
                  addToCartBusiness={addToCartBusinessHandler}
                  track={track}
                  isCheck={isCheck}
                />
                <MobileModelComponent
                  voucherData={voucherData}
                  isEditMode={isEditMode}
                  isEnabled={isB2bButtonEnabled()}
                  isEnabledSaveBtn={isB2bButtonEnabled()}
                  isKeyboardOpen={isKeyboardOpen}
                  isB2bEnabled={isB2bEnabled}
                  entityData={entityData}
                  openModal={() => {
                    setModalOpen(true);
                    track({
                      [GEV.AMPLITUDE_EVENT_NAME]: AMP_EVENT_NAME.PREVIEW,
                      [GEV.EVENT_CAT]: 'Egifting',
                      [GEV.MEMBER_TYPE]: 'B2B',
                      vertical: 'egifting',
                      [GEV.AMPLITUDE_CTA_LOCATION]: EGIFTING_CUSTOMIZE,
                    });
                  }}
                  cancelButon={() => {
                    track({
                      [GEV.AMPLITUDE_EVENT_NAME]: AMP_EVENT_NAME.CUSTOMISATION_CANCELLED,
                      [GEV.MEMBER_TYPE]: 'B2B',
                      [GEV.AMPLITUDE_VERTICAL]: AMP_EVENT_NAME.VERTICAL,
                      [GEV.AMPLITUDE_CTA_LOCATION]: EGIFTING_CUSTOMIZE,
                      [GEV.AMPLITUDE_CTA_SUB_LOCATION]: null,
                    });
                    setIsEditMode(false);
                    const windowVar = typeof window !== 'undefined' && window;
                    windowVar.location.href = '/cart/';
                  }}
                  addToCartBusiness={addToCartBusinessHandler}
                />
                <PreviewModel
                  open={modalOpen}
                  isB2bEnabled={isB2bEnabled}
                  voucherData={voucherData}
                  isEditMode={isEditMode}
                  closeModal={() => setModalOpen(false)}
                  voucherMetaData={voucherMetaData}
                />
              </BusinessGridStyle>
            ) : (
              <GridFive id="grid-five no-spacing">
                <Preview
                  setErrorBanner={setErrorBanner}
                  isEnabled={isEnabled}
                  voucherData={voucherData}
                  isEditMode={isEditMode}
                  isB2bEnabled={isB2bEnabled}
                  setIsEditMode={setIsEditMode}
                  voucherMetaData={voucherMetaData}
                  isEnabledSaveBtn={isEnabledSaveBtn}
                  isKeyboardOpen={isKeyboardOpen}
                  track={track}
                  trackEvents={trackEvents}
                  setIsError={setIsError}
                />
              </GridFive>
            )}
          </GridPreview>
        </Grid>

        <TosterComponent isError={isError} />
      </Grid>
    </StyledContainer>
  );
};

const trackHandler = (track, voucherData) => {
  const valueChecking = (value, error) => {
    if (error) {
      return 'E';
    }
    if (value === '') {
      return 'N';
    }
    return 'Y';
  };
  track({
    [GEV.PAGE_TYPE]: PAGE_TYPES.VOUCHER,
    [GEV.SCREEN_NAME]: SCREEN_NAME.CUSTOMISE,
    [GEV.EVENT_CAT]: CATEGORY.VOUCHER,
    [GEV.EVENT_ACTION]: 'click',
    [GEV.EVENT_LABEL]: `gift_category:${valueChecking(
      voucherData.metadata.category
    )}|gift_design:${valueChecking(voucherData.metadata.image)}|gift_value:${valueChecking(
      voucherData.amount,
      !(voucherData.amount >= 5 && voucherData.amount <= 1000)
    )}|gift_recipient:${recipientTrack}|gift_message:${valueChecking(
      voucherData.metadata.message
    )}|gift_date:${valueChecking(voucherData.metadata.deliveryTime)}`,
  });
};

const editGuestGifts = async (
  auth0Token,
  guest,
  setVoucherData,
  slug,
  setRecepient,
  isB2bButtonEnabled
) => {
  if (!auth0Token && guest) {
    const response = await getViewGuest(guest.id, slug, guest.signature);
    const data = _get(response, 'data', []);
    setVoucherData({
      ...data,
      metadata: {
        ...data.metadata,
        catergory: data.metadata.catergory || 'all',
        deliveryTime: new Date(data.metadata.deliveryTime),
      },
    });
    Agreegate(data.receivers, setRecepient);
  } else {
    try {
      const response = await getViewGuest('', slug, '', auth0Token);
      const { data = [] } = response;
      if (isB2bButtonEnabled) {
        data.denominations.map((denomination) => {
          return {
            qty: denomination.quantity,
            amount: denomination.amount,
          };
        });
        data.isFetch = true;
      }

      setVoucherData({
        ...data,
        metadata: {
          ...data.metadata,
          catergory: data.metadata.catergory || 'all',
          deliveryTime: new Date(data.metadata.deliveryTime),
        },
      });
      Agreegate(data.receivers, setRecepient);
    } catch (error) {
      if (error instanceof ErrorUnauthorized) {
        console.log(error, 'error fetching guest details');
      } else {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    }
  }
};
const recepientHandler = (field) => {
  if (
    field.name.trim() !== '' &&
    ((field.email !== '' && validateEmail(field.email)) ||
      (field.phone !== '' && phoneFormat(field.phone)))
  ) {
    recipientTrack = 'Y';
    enableRecipient = true;
  } else if (field.name.trim() === '' && (field.email === '' || field.phone === '')) {
    recipientTrack = 'N';
  } else {
    enableRecipient = false;
    recipientTrack = 'E';
  }
  return enableRecipient;
};

const CustomiseVoucher = ({
  track,
  auth0: { loginWithRedirect },
  errorBannerTestProps = false,
  errorMessage = 1,
}) => {
  const router = useRouter();
  const { slug } = router.query;
  const { isEditMode, setIsEditMode, voucherMetaData, user } = useContext(CustomiseVoucherContext);
  const {
    userState: { guest, auth0Token },
  } = useUserContext();
  const [selectedVoucher, setSelectedVoucher] = useState({});
  const filteredCategory = getCustomisationList(voucherMetaData);
  const counterContainerRef = useRef();
  const counterInputRef = useRef();
  const { isReady } = useFeatureFlag();
  const [manuallyMsg, setManuallymsg] = useState(false);
  const [category, setCategory] = useState('all');
  const [recepient, setRecepient] = useState([dummyarray]);
  const date = new Date();
  const [voucherData, setVoucherData] = useState({
    amount: '',
    sender: (user && user.name) || '',
    quantity: 1,
    index: 0,
    metadata: {
      deliveryTime: date.setHours(0, 0, 0, 0),
      catergory: 'all',
      image: selectedVoucher?.png || filteredCategory[0]?.png,
      message: selectedVoucher?.message || '',
      name: selectedVoucher?.name || '',
    },
    denominations: [],
    receivers: recepient,
  });
  const { isB2BSite, entityData } = useBusinessEntityData();

  useEffect(() => {
    if (voucherMetaData.length > 0 && !isEditMode) {
      setVoucherData((prev) => {
        return {
          ...prev,
          metadata: {
            ...prev.metadata,
            image: selectedVoucher?.png || filteredCategory[0]?.png,
            message: selectedVoucher?.message || filteredCategory[0]?.message,
            name: selectedVoucher?.name || '',
          },
        };
      });
    }
    return () => nookies.destroy({}, 'selectedVoucher');
  }, [voucherMetaData]);

  useEffect(() => {
    const { selectedVoucher: selectedVoucherNookies } = nookies.get('selectedVoucher') || {
      selectedVoucher: '{}',
    };
    if (selectedVoucherNookies && Object.keys(selectedVoucher || {}).length === 0 && !isEditMode) {
      const parseData = JSON.parse(selectedVoucherNookies);
      setSelectedVoucher(parseData);
    }
    if (!isEditMode) {
      setVoucherData({
        ...voucherData,
        metadata: {
          ...voucherData.metadata,
          catergory: selectedVoucher?.category,
          message: selectedVoucher?.message,
        },
      });
    }

    return () => nookies.destroy({}, 'selectedVoucher');
  }, [selectedVoucher]);

  const filteredImg = voucherMetaData
    .filter((item) => !isPastDate(item?.end, true) && isPastDate(item?.start, true))
    .filter((item) => {
      if (voucherData.metadata.catergory === 'all') {
        return item;
      }
      return item.catergory === voucherData.metadata.catergory;
    });
  /* eslint-disable no-useless-escape */
  recepient.map((field) => {
    return recepientHandler(field);
  });

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    let label;
    if (slug) {
      setIsEditMode(true);
      editGuestGifts(auth0Token, guest, setVoucherData, slug, setRecepient, isB2BSite);
      label = 'gifting_cart_edit_page';
    } else {
      setIsEditMode(false);
      label = 'gifting_customize_voucher_page';
    }
    if (!isB2BSite) {
      track({
        [GEV.PAGE_TYPE]: PAGE_TYPES.CUSTOMISE,
        [GEV.SCREEN_NAME]: SCREEN_NAME.CUSTOMISE,
        [GEV.EVENT_CAT]: CATEGORY.VOUCHER,
        [GEV.EVENT_ACTION]: 'landed',
        [GEV.EVENT_LABEL]: label,
      });
    }
  }, [auth0Token, slug]);
  useEffect(() => {
    setVoucherData({
      ...voucherData,
      message: selectedVoucher?.message || filteredCategory[0]?.message,
      sender: user && user.name,
    });
  }, [user]);
  const handleTouchStart = (event) => {
    event.stopPropagation();
    const primaryTouch = event.targetTouches && event.targetTouches[0];
    const targetElement = primaryTouch?.target;
    if (!isDescendant(counterContainerRef, targetElement)) {
      counterInputRef.current.blur();
    }
  };
  const trackEvents = () => trackHandler(track, voucherData);
  useEffect(() => {
    const windowVar = typeof window !== 'undefined' && window;
    windowVar.addEventListener('touchstart', handleTouchStart);
    Agreegate(voucherData.receivers, setRecepient);
    document.addEventListener('mousemove', () => {
      nookies.set({}, LAST_ACTIVITY, new Date());
    });
    document.addEventListener('click', () => {
      nookies.set({}, LAST_ACTIVITY, new Date());
    });
    document.addEventListener('keydown', () => {
      nookies.set({}, LAST_ACTIVITY, new Date());
    });

    return () => {
      setSelectedVoucher();
      windowVar.removeEventListener('touchstart', handleTouchStart);
      trackEvents();
    };
  }, []);
  const timeInterval = setInterval(() => {
    let { [LAST_ACTIVITY]: lastAcivity } = nookies.get();
    lastAcivity = lastAcivity && !isEmpty(lastAcivity) ? lastAcivity : undefined;
    const diffMs = Math.abs(new Date(lastAcivity) - new Date()); // milliseconds between now & last activity
    const seconds = Math.floor(diffMs / 1000);
    const minute = Math.floor(seconds / 60);
    if (minute === 30 && seconds >= 1800) {
      clearInterval(timeInterval);
      trackEvents();
      nookies.set({}, LAST_ACTIVITY, new Date());
    }
  }, 1000);
  if (!isReady) {
    return <Loader />;
  }

  return (
    <>
      <Container ref={counterContainerRef} isB2bEnabled={isB2BSite}>
        <WrpDiv isB2bEnabled={isB2BSite}>
          <NdsThemeProvider>
            <PageContent>
              <CustomisePage
                voucherData={voucherData}
                setVoucherData={setVoucherData}
                manuallyMsg={manuallyMsg}
                setManuallymsg={setManuallymsg}
                filteredImg={filteredImg}
                setCategory={setCategory}
                category={category}
                recepient={recepient}
                setRecepient={setRecepient}
                counterInputRef={counterInputRef}
                track={track}
                trackEvents={trackEvents}
                loginWithRedirect={loginWithRedirect}
                errorBannerTestProps={errorBannerTestProps}
                errorMessage={errorMessage}
                entityData={entityData}
                isB2bEnabled={isB2BSite}
              />
            </PageContent>
          </NdsThemeProvider>
        </WrpDiv>
      </Container>
      <ShowFooterSection>
        <PageFooter />
      </ShowFooterSection>
    </>
  );
};

const CustomiseVoucherWrapper = (props) => (
  <EventTrackingContext.Consumer>
    {({ track }) => <CustomiseVoucher {...props} track={track} />}
  </EventTrackingContext.Consumer>
);

export default withAuth0(CustomiseVoucherWrapper);
